import type { CommentTag } from "./comments/CommentViewModel";
import type { BackgroundLayerJSON } from "./BackgroundLayer";


export interface GlobalDefaultConfig {
  introMessage: string;
  infoHTML: string;
  name: string;
  hasMax: boolean | undefined;
  commentsEnabled: boolean;
  commentsReadOnly: boolean;
  additionalLayers: BackgroundLayerJSON[];
  modellCommentTagSet: CommentTag[];
  offsetZoom: boolean;
  maxZoomConstraint: number;
  extentConstraint: number[] | undefined;
  setConstraint: boolean;
  defaultBackgroundLayerIndex: number;
  backgroundLayers: BackgroundLayerJSON[];
  logo: string | undefined;
  logoLink: string | undefined;
  logoWidth: number | undefined;
  logoHeight: number | undefined;
  datenschutz: string | undefined;
  [key: string]: any;
}


const globalDefaultConfig : GlobalDefaultConfig = {
  "introMessage": "",
  "infoHTML": "",
  "name": "",
  "hasMax": undefined,
  "commentsEnabled": false,
  "commentsReadOnly": false,
  "additionalLayers": [
  ],
  "modellCommentTagSet": [],
  "offsetZoom": false,
  "maxZoomConstraint": Infinity,
  "extentConstraint": undefined,
  "setConstraint": false,
  "defaultBackgroundLayerIndex": 0,
  "backgroundLayers": [
    { type: "Satellite" },
    { type: "OSM" }
  ],
  "logo": undefined,
  "logoLink": undefined,
  "logoWidth": undefined,
  "logoHeight": undefined,
  "datenschutz": undefined,
  
}

export default globalDefaultConfig;